import { getCurrentUrl, getPageName, getPageMeta, getQueryParam, setCookie, getCookie } from 'utilities';
import { instrumentedClickHandler, onPageHideHandler, onVisibilityChangeHandler } from './handlers';
import { fetchEmail } from 'fetchEmail';

export function createImpactSessionCookie() {
  const cookieName = 'irclickid';
  const id = getQueryParam(cookieName);

  if (!id) return;

  // If irclickid param is present, create a cookie session.
  setCookie(cookieName, id);
}

export function addEventListeners() {
  // We need to listen to 'pagehide' events because 'visibilitychange'
  //  events are not guaranteed to fire on all browsers
  document.addEventListener('pagehide', onPageHideHandler);
  document.addEventListener('click', instrumentedClickHandler);

  // We need to listen to 'visibilitychange' events
  // because 'pagehide' is not guaranteed to fire on mobile
  document.addEventListener('visibilitychange', onVisibilityChangeHandler);
}

export function isDocumentVisible() {
  return document.visibilityState !== 'hidden';
}

export async function tryPopulateEmail() {
  if (window.BPFTracking.cookiesSet) {
    const inputs = document.querySelectorAll("input[type='email']");
    const uidCookie = getCookie('uid');
    const autoSet = getQueryParam('bpf_autofill');

    if (autoSet && inputs.length > 0 && !!uidCookie) {
      const email = await fetchEmail(uidCookie);
      inputs.forEach(e => e.value ||= email);
    }
  } else {
    await new Promise((resolve) => {
      window.addEventListener(
        'bpfAnalyticsCookiesSet',
        async function () {
          await tryPopulateEmail();
          resolve();
        },
        { once: true },
      );
    });
  }
}
